import NProgress from 'nprogress';
import publicRoute from '@/router/publicRoute';
import whiteList from '@/router/whiteList';
import fetchUserRoute from '@/router/userRoute';
import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/store/user';
import { getToken, removeToken } from '@/util/common';
import { PREFIX ,PLATFORM_NAME, VERSION } from "@/util/variable";

const router = createRouter({
    history: createWebHistory(),
    routes: publicRoute
});

// 重置路由（登出时调用）
export const resetRouter = () => {
    const userStore = useUserStore();
    // 移除所有动态添加的路由
    router.getRoutes().forEach(route => {
        // 只保留 publicRoute 中的路由
        const isPublic = publicRoute.some(p => p.path === route.path || p.name === route.name);
        if (!isPublic && route.name) {
            router.removeRoute(route.name);
        }
    });
    // 清除 store 中的路由
    userStore.setRoutes([]);
};

// 路由守卫
router.beforeEach((to, from, next) => {
    NProgress.start();
    window.document.title = `${to.meta.title || ''} ${PLATFORM_NAME}`;
    const userStore = useUserStore();
    
    // 白名单路由直接放行
    if (whiteList.indexOf(to.path) !== -1) {
        next();
        NProgress.done();
        return;
    }

    // 检查是否有 token
    if (getToken()) {
        // 有 token，加载动态路由
        if (!userStore.routes || userStore.routes.length === 0) {
            fetchUserRoute().then((routes) => {
                routes.forEach(route => {
                    router.addRoute(route);
                });
                // 添加404捕获路由（必须最后添加）
                router.addRoute({
                    path: '/:pathMatch(.*)*',
                    redirect: '/404'
                });
                userStore.setRoutes(routes);
                next({ ...to, replace: true });
            });
        } else {
            next();
        }
    } else {
        // 没有 token，清除缓存并跳转登录页
        clearCache();
        window.location.href = "/login";
        // next({ path: '/login', query: { redirect: to.path } });
        NProgress.done();
    }
});

// 删除缓存，token
function clearCache(){
    // removeToken();
    localStorage.clear();
    sessionStorage.clear();
    // Object.keys(localStorage).forEach(item => item.startsWith(PREFIX) ? localStorage.removeItem(item) : '');
    // Object.keys(sessionStorage).forEach(item => item.startsWith(PREFIX) ? sessionStorage.removeItem(item) : '');
}

export default router;
